import { Contract } from "../contracts/contract.model";

export class RequestContract {
  id: number;
  requestId: number;
  contractId: number;
  contract: Contract;
}
